export const agents = {
  title: "Agents",
  subtitle: "Create and manage agents to automate your tasks",
  newAgent: "New Agent",
  noAgents: "No agents found",
  edit: "Edit",
  delete: "Delete",
  name: "Name",
  description: "Description",
  systemPrompt: "System Prompt",
  greeting: "Greeting",
  created: "Created on {{date}}",
  profilePicture: "Profile Picture URL",
  temperature: "Temperature",
  model: "Model",
  tools: "Tools",
  create: "Create Agent",
  table: {
    title: "Name",
    description: "Description",
    tools: "Tools",
    actions: "Actions",
    model: "Model",
  },
  actions: {
    edit: "Edit",
    delete: "Delete",
    copyId: "Copy ID",
    embed: "Embed",
    embedCodeCopied:
      "Código de incorporação copiado para a área de transferência",
    embedCodeCopiedDescription: "Você pode colar em qualquer lugar",
  },
  character: "Character",
  update: "Update",
  usageMode: "Usage Mode",
  anonymous: "Anonymous",
  authenticated: "Authenticated",
};
